<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="fm1">
<h1 class="subchapter">ROUGH LANDING</h1>
<p class="indent">I felt our sled bounce when it touched down, throwing us back into the air before we came down to stay, careening across the ground, through underbrush, knocking small trees flat, using friction as much as the reversed thrust of the craft’s two engines to help stop us. “Get ready!” I warned my people. “When the hatches pop, get out fast.” I don’t know if anyone heard me. We were jerked from side to side several times, and when the airsled finally came to a stop and the overhead hatches popped open, we were canted at a thirty-degree angle to the right.</p>
<p class="indent">“Up and out!” I shouted over my radio link as I reached up to use the edges of the hatch over my head to pull myself out of the sled. “Head for the rendezvous point.”</p>
<p class="indent">We were on the surface of an enemy world.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781936535415_epub_fm1_r1.vue?6cfa6f17